import { motion } from "motion/react";
import { t } from "@/lib/i18n";
import type { AboutSection as AboutData } from "@/data/profile";
import type { SectionProps } from "../types";
import { SectionFrame } from "../SectionFrame";

export function AboutSection({ section, number, ctx }: SectionProps<AboutData>) {
  const { lang, presets } = ctx;

  return (
    <SectionFrame number={number} kicker={section.kicker} title={section.title} ctx={ctx}>
      <motion.p
        variants={presets.rise(0.16)}
        style={{ fontSize: 17, lineHeight: 1.62, color: "var(--tc-text)", maxWidth: 560, textWrap: "pretty" }}
      >
        {t(section.body, lang)}
      </motion.p>

      <motion.blockquote
        variants={presets.rise(0.22)}
        style={{
          margin: "18px 0",
          padding: "12px 18px",
          borderLeft: "2px solid var(--tc-brass)",
          background: "color-mix(in srgb, var(--tc-paper) 60%, transparent)",
          fontFamily: "var(--tc-serif)",
          fontStyle: "italic",
          fontSize: 18,
          lineHeight: 1.35,
          color: "var(--tc-text)",
          maxWidth: 560,
        }}
      >
        {t(section.quote, lang)}
      </motion.blockquote>

      <motion.div variants={presets.rise(0.28)} style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {section.interests.map((tag) => (
          <span
            key={t(tag, lang)}
            style={{
              fontFamily: "var(--tc-mono)",
              fontSize: 12,
              color: "var(--tc-muted)",
              border: "1px solid var(--tc-line-3)",
              background: "var(--tc-paper)",
              borderRadius: 999,
              padding: "6px 13px",
            }}
          >
            {t(tag, lang)}
          </span>
        ))}
      </motion.div>
    </SectionFrame>
  );
}
